import { checkLicense } from '@jira/spa-apps__interceptors/src/checkLicense.tsx';
import getServiceDeskData from '@jira/router-resources__service-desk-context/src/getData.tsx';
import {
	createResource,
	type RouterDataContext,
	type ResourceStoreContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { fetchJson } from '@atlassian/jira-fetch/src/index.tsx';

type PillItem = {
	pill_id: string;
	pill_category: string;
	pill_content: string;
	intent: string;
	goal: string;
	trigger_summary: string;
	confidence: number;
	priority: number;
	example: string;
};

type PillsResponse = {
	pills: PillItem[];
};
const RESOURCE_TYPE_DRAFT_REPLY_PILLS = 'DRAFT_REPLY_PILLS_RESOURCE';

export const draftReplyPillsResource: RouteResource<PillsResponse | null> =
	createResource<PillsResponse | null>({
		type: RESOURCE_TYPE_DRAFT_REPLY_PILLS,
		getKey: ({ match, query }) => {
			const issueKey = match.params.issueKey || query.selectedIssue || '';
			return `draftReplyPillsResource-${issueKey}`;
		},
		getData: async (
			routerDataContext: RouterDataContext,
			resourceStoreContext: ResourceStoreContext,
		) => {
			const issueKey =
				routerDataContext.match.params.issueKey || routerDataContext.query.selectedIssue || '';
			if (!issueKey) {
				return null;
			}
			// Check if service desk is enabled
			if (!checkLicense(resourceStoreContext.tenantContext, 'servicedesk')) {
				return null;
			}
			// Serviedesk context call to identify agent permission
			// if role is not agent-project-admin or agent then return null
			const serviceDeskContext = await getServiceDeskData(routerDataContext, resourceStoreContext);
			if (
				!(
					serviceDeskContext.userRole === 'agent-project-admin' ||
					serviceDeskContext.userRole === 'agent'
				)
			) {
				return null;
			}
			try {
				const endpoint = `/gateway/api/firebolt/1/agent-response/pills/work-item/${issueKey}`;
				const response = await fetchJson<PillsResponse>(endpoint, {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
					},
				});
				return response;
			} catch (error) {
				return null;
			}
		},
		maxAge: 0,
		isBrowserOnly: true,
	});

export const getDraftReplyPillsResource = (): RouteResource<PillsResponse | null>[] => {
	return [];
};
